exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-box {\n  border-left: 0.1px groove white;\n  height: 80%;\n}", ""]);

// exports
